export default {"src":"/_next/static/media/supports.9eec30aa.svg","height":227,"width":227,"blurWidth":0,"blurHeight":0};